import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import React from "react";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import ValidateDialog from "./ValidateDialog";
import API from "@/api/serverCall";
import Button from "@/components/Button";
import { Typography } from "@mui/material";
import { queryStringGetter } from "@/utils/global";
import { NotFound } from "@/views/NotFound";
import { signUp } from "@/redux/slices/auth";
import { useDispatch } from "react-redux";
import { VerifyEmailResponseDto } from "@/api/interface";

const validationSchema = yup.object({
	nameFirst: yup.string().trim().required("이름은 필수입니다"),
	nameLast: yup.string().trim().required("성은 필수입니다"),
	password: yup
		.string()
		.required("비밀번호는 필수입니다")
		.matches(
			/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,20}$|^(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}$|^(?=.*[^a-zA-Z0-9])(?=.*[0-9]).{8,20}$/,
			"8~20자 사이, 영문(대소문자)+숫자+특수문자 중 2종류 이상을 조합하여 사용할 수 있습니다",
		),
});

export default function MemberInvite({ location }: any) {
	const history = useHistory();
	const dispatch = useDispatch();
	const { enqueueSnackbar } = useSnackbar();

	const [Mailvalidate, setMailvalidate] = React.useState(true);
	const [inviteEmail, setInviteEmail] = React.useState("");
	const urlSearchValue = queryStringGetter(location.search);

	const handleModalClose = () => {
		setMailvalidate(false);
	};

	const checkMailvalidate = (token: any) => {
		// for loading
		try {
			const requestData = {
				token,
			};
			API.POST<VerifyEmailResponseDto>({
				link: `/common/verify/email`,
				body: requestData,
				loginRequest: true,
			})
				.then((response) => {
					if (response.status === 200) {
						setMailvalidate(true);
						setInviteEmail(response.data.email);
					}
				})
				.catch((error) => {
					setMailvalidate(false);
				});
		} catch (error) {
			console.error(error);
		}
	};

	const formik = useFormik({
		initialValues: {
			nameFirst: "",
			nameLast: "",
			password: "",
		},
		validationSchema,
		onSubmit: (values) => {
			const requestData = {
				token: urlSearchValue.token,
				nameFirst: values.nameFirst,
				nameLast: values.nameLast,
				email: inviteEmail,
				password: values.password,
				snsId: "",
				loginType: "email",
			};
			dispatch(
				signUp({
					requestData,
					callback: () => history.push("/"),
					enqueueSnackbar,
				}),
			);
		},
	});

	React.useEffect(() => {
		if (urlSearchValue.token) {
			checkMailvalidate(urlSearchValue.token);
		}
	}, [urlSearchValue.token]);

	return urlSearchValue.token ? (
		<div
			style={{
				width: "35rem",
				margin: "10rem  auto ",
				display: "flex",
				flexDirection: "column",
				textAlign: "center",
			}}
		>
			<ValidateDialog
				Mailvalidate={Mailvalidate}
				handleModalClose={handleModalClose}
			/>

			<Typography
				style={{ marginBottom: "1rem", fontWeight: "bold", fontSize: "3rem" }}
			>
				무료 평가판 시작
			</Typography>
			<Typography
				style={{ fontSize: "1.2rem", marginBottom: "3rem", color: "#000000" }}
			>
				Foodlens에 초대되었습니다
			</Typography>
			<Box sx={{ width: "100%", typography: "body1", margin: "auto" }}>
				<form onSubmit={formik.handleSubmit}>
					<Box
						sx={{
							maxWidth: "100%",
							marginBottom: "1rem",
							display: "flex",
							justifyContent: "space-between",
						}}
					>
						<div style={{ width: "49%" }}>
							<Typography sx={{ color: "#0d0d0d94", textAlign: "left" }}>
								이름
							</Typography>
							<TextField
								id="nameFirst"
								name="nameFirst"
								fullWidth={true}
								value={formik.values.nameFirst}
								onChange={formik.handleChange}
								error={
									formik.touched.nameFirst &&
									Boolean(formik.errors.nameFirst)
								}
								helperText={
									formik.touched.nameFirst && formik.errors.nameFirst
								}
							/>
						</div>
						<div style={{ width: "49%" }}>
							<Typography sx={{ color: "#0d0d0d94", textAlign: "left" }}>
								성
							</Typography>
							<TextField
								id="nameLast"
								name="nameLast"
								fullWidth={true}
								value={formik.values.nameLast}
								onChange={formik.handleChange}
								error={
									formik.touched.nameLast &&
									Boolean(formik.errors.nameLast)
								}
								helperText={
									formik.touched.nameLast && formik.errors.nameLast
								}
							/>
						</div>
					</Box>
					<Box
						sx={{
							maxWidth: "100%",
							marginBottom: "1rem",
						}}
					>
						<Typography sx={{ color: "#0d0d0d94", textAlign: "left" }}>
							이메일
						</Typography>
						<TextField
							fullWidth={true}
							id="email"
							name="email"
							value={inviteEmail}
							disabled={true}
							sx={{ marginBottom: "1rem" }}
						/>
						<Typography sx={{ color: "#0d0d0d94", textAlign: "left" }}>
							비밀번호
						</Typography>
						<TextField
							fullWidth
							id="password"
							name="password"
							type="password"
							value={formik.values.password}
							onChange={formik.handleChange}
							error={
								formik.touched.password && Boolean(formik.errors.password)
							}
							helperText={formik.touched.password && formik.errors.password}
						/>
					</Box>
					<Button
						variant="contained"
						sx={{
							backgroundColor: "#0071E3",
							height: "3.5rem",
							marginBottom: "2rem",
							fontWeight: "bold",
							fontSize: "1.2rem",
						}}
						type="submit"
						fullWidth={true}
					>
						회원가입
					</Button>
				</form>
			</Box>
		</div>
	) : (
		<NotFound />
	);
}
